import { Stack, Typography } from "@mui/material";
import { useLangContext } from "../../../context/langContext";
import { useProfileContext } from "../../../context/profileContext";

const compInfos = {
  fa: {
    balance: "موجودی",
    units: {
      price: "تومان",
    },
    buttonText: "افزایش",
  },
  en: {
    balance: "موجودی",
    units: {
      price: "تومان",
    },
    buttonText: "افزایش",
  },
};

export default function UserAccountComponent() {
  const { userProfile } = useProfileContext();
  const { lang } = useLangContext();
  return (
    <Stack
      width="100%"
      direction="row"
      justifyContent="center"
      alignItems="center"
      py="24px"
      bgcolor={(theme) => theme.palette.gray[50]}
    >
      <Stack direction="column" alignItems="center">
        <Stack mb="6px">
          <img src="/images/profileImg.svg" alt="profileImage" />
        </Stack>
        <Typography variant="footerMediumBold" mb="6px">
          {userProfile?.name}
        </Typography>
        <Typography
          dir="ltr"
          variant="warningRegular"
          color={(theme) => theme.palette.dark[40]}
        >
          {userProfile?.mobile}
        </Typography>
      </Stack>
    </Stack>
  );
}
